import * as React from "react";
import { PanelStack, Classes, IPanel } from "@blueprintjs/core";
import { useTl } from "../../../../hooks";
import styled from "styled-components";
import { VeterinaryDto } from "../../../../api";
import { ClinicVeterinariesSelectorPanel } from "./ClinicVeterinariesSelectorPanel";
import {
  ClinicVeterinariesControlFormPanel,
  IClinicVeterinariesControlFormPanelProps,
} from "./ClinicVeterinariesControlFormPanel";
import { ETLCodes } from "../../../../locales";

export interface IClinicVeterinariesPanelSelectorProps
  extends Pick<IClinicVeterinariesControlFormPanelProps, "onSaved"> {
  clinicId: number;
}

const Container = styled.div`
  flex: 1;
  height: 100%;
  & > .${Classes.PANEL_STACK} {
    height: 100%;
  }
`;

export const ClinicVeterinariesPanelStack: React.FunctionComponent<IClinicVeterinariesPanelSelectorProps> = ({
  clinicId,
  onSaved,
}) => {
  const { t } = useTl();

  const onVeterinarySelected = React.useCallback(
    (data: VeterinaryDto) => {
      setPanelStack((currentStack) => [
        ...currentStack,
        {
          component: () => (
            <ClinicVeterinariesControlFormPanel
  onSaved={onSaved}
  veterinary={data}
  />
          ),
        },
      ]);
    },
    [onSaved]
  );

  const [panelStack, setPanelStack] = React.useState<IPanel[]>([
    {
      component: () => (
        <ClinicVeterinariesSelectorPanel onVeterinarySelected={onVeterinarySelected}/>
      ),
      title: t(ETLCodes.Veterinarians),
    },
  ]);

  const removeFromPanelStack = React.useCallback(() => {
    setPanelStack((prev) => prev.slice(0, prev.length - 1));
  }, [setPanelStack]);

  return (
    <Container className={Classes.DIALOG_BODY}>
      <PanelStack stack={panelStack} showPanelHeader={true} onClose={removeFromPanelStack}/>
    </Container>
  );
};
